/**
 * Beneficiaries Mapper
 * Funzioni pure per la gestione dei beneficiari in sidebar-guest
 */

/**
 * Trasforma la risposta API beneficiaries in un array di options per la select
 * @param {Object} apiBeneficiaries - Oggetto beneficiaries dalla risposta API
 * @returns {Array} Array di options { value, name, surname, fiscalCode, email, text }
 */
export function map_beneficiaries_response(apiBeneficiaries) {
  if (!apiBeneficiaries) return []

  return Object.values(apiBeneficiaries).map(ben => ({
    value: ben.id,
    name: ben.name,
    surname: ben.surname,
    fiscalCode: ben.fiscalCode,
    email: ben.email,
    text: ben.name + ' ' + ben.surname
  }))
}

/**
 * Trasforma le beneficiary relations in options per la select
 * @param {Array} relations - Array di relations dalla risposta API
 * @returns {Array} Array di options { value, name, text }
 */
export function map_beneficiary_relations(relations) {
  if (!relations || !Array.isArray(relations)) return []

  return relations.map((rel, key) => ({
    value: key,
    name: rel,
    text: rel
  }))
}

/**
 * Trova un beneficiario dato l'ID
 * @param {Array} beneficiaries - Array di beneficiari mappati
 * @param {string|number} id - ID del beneficiario da cercare
 * @returns {Object|null} Beneficiario trovato o null
 */
export function find_beneficiary_by_id(beneficiaries, id) {
  if (!beneficiaries || !id) return null

  return beneficiaries.find(b => b.value === id) || null
}

/**
 * Estrae i campi guest da un beneficiario
 * @param {Object} beneficiary - Oggetto beneficiario
 * @returns {Object} Campi { firstName, lastName, email }
 */
export function extract_guest_fields_from_beneficiary(beneficiary) {
  if (!beneficiary) {
    return {
      firstName: '',
      lastName: '',
      email: ''
    }
  }

  return {
    firstName: beneficiary.name || '',
    lastName: beneficiary.surname || '',
    email: beneficiary.email || ''
  }
}

/**
 * Ottiene l'ID del primo beneficiario (default)
 * @param {Array} beneficiaries - Array di beneficiari mappati
 * @returns {string|number|null} ID del primo beneficiario o null
 */
export function get_default_beneficiary_id(beneficiaries) {
  if (!beneficiaries || beneficiaries.length === 0) return null

  return beneficiaries[0].value
}